import AddToCalendarModal from './addToCalendarModal.view';

export default AddToCalendarModal;
